import { ViewFile } from '@/components/ats';
import { PDFReaderBrowser } from '@/components/file-viewers/reactPdf';
import { KText } from '@/ui-library/components/text';
import { Center, Flex } from '@chakra-ui/react';
import { useMemo } from 'react';
import { InterviewType } from '../types/interview';

export const InterviewResume = ({
  interview,
}: {
  interview: InterviewType;
}) => {
  const { resume = {} } = interview?.candidate || {};
  // Backend mints a new presigned URL on every interview refetch. Keying the
  // url/content_type/preview url to `resume.id` keeps the iframe `src` stable
  // for the same file, so the PDF doesn't reload on window focus / refetches.
  const stableResume = useMemo(
    () => ({
      url: resume?.url,
      content_type: resume?.content_type,
      preview_url: resume?.preview?.url,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [resume?.id]
  );
  const isPreviewAvailable =
    [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/x-ole-storage',
    ]?.includes(stableResume.content_type) && stableResume.preview_url;

  if (stableResume.content_type !== 'application/pdf' && !isPreviewAvailable)
    return (
      <Center h="100%" flexDir="column" gap="12px">
        <KText fontSize="sm">Resume preview unavailable for this format</KText>
        <ViewFile file={resume} />
      </Center>
    );

  return (
    <Flex w="100%" h="100%" flexDir="column">
      <PDFReaderBrowser
        file={stableResume.url}
        content_type={stableResume.content_type}
        preview_url={stableResume.preview_url}
        fileName={interview?.candidate?.name}
        showReplaceControl={false}
        styles={{
          container: {
            border: 'none',
          },
        }}
      />
    </Flex>
  );
};
